import * as React from 'react';

import cn from 'classnames';

import { IconSolidHeart, IconRegularHeart } from '@notino/react-styleguide';

import { heartPulseClass, StyledPulsatingHeart } from './styled';

interface IPulsatingHeartProps {
  wishlisted: boolean;
  loading: boolean;
  width?: string;
  height?: string;
  className?: string;
}

export const PulsatingHeart: React.FC<IPulsatingHeartProps> = ({
  wishlisted,
  loading,
  className,
}) => {
  return (
    <StyledPulsatingHeart
      data-testid="wishlist"
      className={cn({ [heartPulseClass]: loading }, className)}
    >
      {wishlisted || loading ? (
        <IconSolidHeart width="20px" height="20px" color="icon.highlight" />
      ) : (
        <IconRegularHeart width="20px" height="20px" color="icon.primary" />
      )}
    </StyledPulsatingHeart>
  );
};
